import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const GroupGochiMenuTableHead = enhance(
  ({ order, orderBy, onRequestSort, roles }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell />
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell sortDirection={orderBy === 'groupId' ? order : false}>
              <TableSortLabel
                active={orderBy === 'groupId'}
                direction={order}
                onClick={() => {
                  onRequestSort('groupId');
                }}
              >
                グループID
              </TableSortLabel>
            </TableCell>
          )}
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
              <TableSortLabel
                active={orderBy === 'menuId'}
                direction={order}
                onClick={() => {
                  onRequestSort('menuId');
                }}
              >
                メニューID
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'groupName'}
              direction={order}
              onClick={() => {
                onRequestSort('groupName');
              }}
            >
              グループ名
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menuName'}
              direction={order}
              onClick={() => {
                onRequestSort('menuName');
              }}
            >
              メニュー名
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'price' ? order : false}>
            <TableSortLabel
              active={orderBy === 'price'}
              direction={order}
              onClick={() => {
                onRequestSort('price');
              }}
            >
              価格
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
            <TableSortLabel
              active={orderBy === 'taxTypeStr'}
              direction={order}
              onClick={() => {
                onRequestSort('taxTypeStr');
              }}
            >
              税区分
            </TableSortLabel>
          </TableCell>
          <TableCell />
          <TableCell />
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(GroupGochiMenuTableHead);
